import FormSection from './FormSection'
import { translations } from '../../data/translations'

const StakeholdersSection = ({ formData, updateFormData, language }) => {
  const t = translations[language]?.stakeholders || translations.de.stakeholders

  const handleCheckboxChange = (field, value) => {
    const currentValues = formData[field] || []
    const newValues = currentValues.includes(value)
      ? currentValues.filter(v => v !== value)
      : [...currentValues, value]
    updateFormData(field, newValues)
  }

  return (
    <FormSection
      title={t.title}
      subtitle={t.subtitle}
    >
      {/* 17.1 Feedback & Freigaben */}
      <div className="subsection">
        <div className="subsection-title">{t.subtitle1}</div>
        
        <div className="form-group">
          <label htmlFor="feedback_personen">{t.feedbackPersonen}</label>
          <textarea
            id="feedback_personen"
            name="feedback_personen"
            value={formData.feedback_personen || ''}
            onChange={(e) => updateFormData('feedback_personen', e.target.value)}
            placeholder={t.feedbackPersonenPlaceholder}
            rows="3"
          />
        </div>

        <div className="form-group">
          <label>{t.feedbackGeschwindigkeit}</label>
          <div className="radio-group">
            {t.feedbackGeschwindigkeitOptionen.map(option => (
              <div key={option.value} className="radio-item">
                <input
                  type="radio"
                  id={`fb-speed-${option.value}`}
                  name="feedback_geschwindigkeit"
                  value={option.value}
                  checked={formData.feedback_geschwindigkeit === option.value}
                  onChange={(e) => updateFormData('feedback_geschwindigkeit', e.target.value)}
                />
                <label htmlFor={`fb-speed-${option.value}`}>{option.label}</label>
              </div>
            ))}
          </div>
        </div>

        <div className="form-group">
          <label>{t.feedbackRunden}</label>
          <div className="radio-group">
            {t.feedbackRundenOptionen.map(option => (
              <div key={option.value} className="radio-item">
                <input
                  type="radio"
                  id={`fb-rounds-${option.value}`}
                  name="feedback_runden"
                  value={option.value}
                  checked={formData.feedback_runden === option.value}
                  onChange={(e) => updateFormData('feedback_runden', e.target.value)}
                />
                <label htmlFor={`fb-rounds-${option.value}`}>{option.label}</label>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* 17.2 Interne Stakeholder */}
      <div className="subsection">
        <div className="subsection-title">{t.subtitle2}</div>
        
        <div className="form-group">
          <label>{t.stakeholderBereiche}</label>
          <div className="checkbox-group" style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))' }}>
            {t.stakeholderOptionen.map(option => (
              <div key={option.value} className="checkbox-item">
                <input
                  type="checkbox"
                  id={`sh-${option.value}`}
                  checked={(formData.stakeholder || []).includes(option.value)}
                  onChange={() => handleCheckboxChange('stakeholder', option.value)}
                />
                <label htmlFor={`sh-${option.value}`}>{option.label}</label>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* 17.3 Kommunikation & Zusammenarbeit */}
      <div className="subsection">
        <div className="subsection-title">{t.subtitle3}</div>
        
        <div className="form-group">
          <label>{t.kommunikationsweg}</label>
          <div className="checkbox-group" style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))' }}>
            {t.kommunikationOptionen.map(option => (
              <div key={option.value} className="checkbox-item">
                <input
                  type="checkbox"
                  id={`kom-${option.value}`}
                  checked={(formData.kommunikation || []).includes(option.value)}
                  onChange={() => handleCheckboxChange('kommunikation', option.value)}
                />
                <label htmlFor={`kom-${option.value}`}>{option.label}</label>
              </div>
            ))}
          </div>
        </div>

        <div className="form-group">
          <label>{t.updateFrequenz}</label>
          <div className="radio-group">
            {t.updateFrequenzOptionen.map(option => (
              <div key={option.value} className="radio-item">
                <input
                  type="radio"
                  id={`upd-${option.value}`}
                  name="update_frequenz"
                  value={option.value}
                  checked={formData.update_frequenz === option.value}
                  onChange={(e) => updateFormData('update_frequenz', e.target.value)}
                />
                <label htmlFor={`upd-${option.value}`}>{option.label}</label>
              </div>
            ))}
          </div>
        </div>
      </div>
    </FormSection>
  )
}

export default StakeholdersSection
